import React, { useState } from "react";
import api from "../../../../utils/api"; // adjust relative path
import MainNavbar from "../../MainNavbar";
import "./AIChat.css";
import ChatMessage from "./ChatMessage";
import { FiSend } from "react-icons/fi";

export default function AIChatPage() {
  const [messages, setMessages] = useState([]); // { sender: 'user'|'bot', text: string }
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    setLoading(true);

    try {
      const res = await api.chat(input);
      // api.chat returns { reply: "..." }
      const botText = res.reply || "⚠️ No reply received.";
      const botMessage = { sender: "bot", text: botText };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      console.error('Chat send error:', error);
      const errorMsg = {
        sender: "bot",
        text: "⚠️ Something went wrong. Please try again.",
      };
      setMessages(prev => [...prev, errorMsg]);
    } finally {
      setLoading(false);
      setInput("");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <>
      <MainNavbar />
      <div className="ai-chat-container">
        <h2 className="ai-chat-title">AI Chat Assistant</h2>

        <div className="chat-box">
          {messages.map((msg, i) => (
            <ChatMessage key={i} sender={msg.sender} text={msg.text} />
          ))}

          {loading && (
            <div className="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>

        <div className="chat-input-box">
          <input
            type="text"
            placeholder="Ask something..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={onKeyDown}
            disabled={loading}
          />
          <button
            className="send-btn"
            onClick={sendMessage}
            disabled={loading || !input.trim()}
          >
            <FiSend size={16} />
          </button>

        </div>
      </div>
    </>
  );
}
  